
import { ModalConfirmCancel } from "./ModalConfirmCancel";

import { ContainerNoSubscription, ContainerSubscription, Content, TextNoSubscription } from "./style";
import { useState, useCallback, useEffect } from "react";
import { DashboardPage } from "../../../components/DashboardPage";
import { ContentOrLoading } from "../../../components/Loadings/ContentOrLoading";
import { ModalSubscription } from "../../../components/Modals/ModalSubscription";
import { SubscriptionCard } from "../../../components/PlansComponents/SubscriptionCard";
import { TransactionList } from "../../../components/PlansComponents/TransactionList";
import { useApi } from "../../../hooks/api";
import { useGlobal } from "../../../hooks/global";
import { useWallet } from "../../../hooks/wallet";
import { correctDateDashboard } from "../../../services/generalServices";
import { HeaderList } from "../../../components/HeaderList";


export const SubscriptionRoot: React.FC = () => {
    const { api } = useApi()
    const _wallet = useWallet()
    const { theme, notify } = useGlobal();

    const [businessIdSelected, setBusinessIdSelected] = useState<string | null>(null)

    const [openModal, setOpenModal] = useState(false)
    const [changePlan, setChangePlan] = useState(false)
    const [openCancelSubscription, setOpenCancelSubscription] = useState(false)
    const [loadingCancelSubscription, setLoadingCancelSubscription] = useState(false)
    const [transaction_selected, setTransactionSelected] = useState<string | null>(null)

    const search = useCallback(async () => {
        await _wallet.forceSearchAll()
    }, [_wallet, businessIdSelected])

    const onSaveSubscription = useCallback(async (transaction_id: string) => {
        notify("Compra de nova assinatura realizada!", "success")
        setOpenModal(false)
        await search()
        setTransactionSelected(transaction_id)
    }, [_wallet])

    const onClickChangePlan = useCallback(() => {
        setChangePlan(true)
        setOpenModal(true)
    }, [])

    const onCloseModal = useCallback(() => {
        setOpenModal(false)
        setChangePlan(false)
    }, [])

    const handleCancelSubscription = useCallback(async () => {
        setLoadingCancelSubscription(true)
        try {
            await api.post(`/subscriptions/cancel/${_wallet.subscription?.id}`)
            notify("Assinatura cancelada com sucesso!", "success")
        } catch (err) {
            notify("Erro ao cancelar assinatura!", "error")
        }
        setOpenCancelSubscription(false)
        setLoadingCancelSubscription(false)
        search()
    }, [_wallet])

    useEffect(() => { search() }, [businessIdSelected])

    useEffect(() => {
        if(!businessIdSelected) {
            _wallet.setSubscription(null);
        }
     }, [businessIdSelected])

    return (
        <DashboardPage>
            <HeaderList
                textHeader="Assinatura"
                textDescritpion={<div dangerouslySetInnerHTML={{ __html: `Última atualização realizada em <b>${correctDateDashboard(_wallet.updatedAt)}</b>` }} /> as any}
                theme={theme}
                haveBorder
                loading={_wallet.loading_all}
                onRefresh={() => search()}
                setBusinessIdSelected={setBusinessIdSelected}
            />

            <ContentOrLoading loading={_wallet.loading_all} text="Buscando assinatura da empresa" theme={theme}>
                <Content>
                    {!_wallet.subscription?.id && !businessIdSelected &&
                        <ContainerNoSubscription>
                            <TextNoSubscription>
                                Selecione uma empresa para visualizar as assinaturas
                            </TextNoSubscription>
                        </ContainerNoSubscription>
                    }
                    {!_wallet.subscription?.id && businessIdSelected &&
                        <ContainerNoSubscription>
                            <TextNoSubscription>
                                 Empresa não tem histórico de assinaturas
                            </TextNoSubscription>
                        </ContainerNoSubscription>
                    }
                    {_wallet?.subscription?.id &&
                        <ContainerSubscription>
                            <SubscriptionCard
                                openCancelSubscription={() => setOpenCancelSubscription(true)}
                                changeCreditCard={() => setOpenModal(true)}
                                changePlan={onClickChangePlan}
                                subscription={_wallet.subscription}
                                theme={theme}
                            />
                            <TransactionList
                                transactions={_wallet.transactions_subscriptions}
                                theme={theme}
                                setTransactionSelected={setTransactionSelected}
                                transaction_selected={transaction_selected}
                            />
                        </ContainerSubscription>
                    }
                </Content>
            </ContentOrLoading>

            {openModal &&
                <ModalSubscription
                    onCancel={onCloseModal}
                    onSave={onSaveSubscription}
                    openModal={openModal}
                    default_plan_id={changePlan ? null : _wallet.subscription?.plan_id}
                />
            }

            {openCancelSubscription &&
                <ModalConfirmCancel
                    loading={loadingCancelSubscription}
                    onCancel={() => !loadingCancelSubscription ? setOpenCancelSubscription(false) : {}}
                    onConfirm={handleCancelSubscription}
                    open={openCancelSubscription}
                />
            }

        </DashboardPage>
    )
}